<template>
    <base-layout :hideHeader="!isShowHeader" title="达人荟会员“完善信息得积分”的活动规则">
        <template slot="main">
            <div class="docs" v-show="isShowDocs" :class="{padding:!!isShowHeader}">
                <h2 v-if="showTitle" style="text-align: center;">达人荟会员“完善信息得积分”的活动规则</h2>
                <ul>
                    <li>
                        一、活动名称：完善信息得积分
                    </li>
                    <li>
                        二、活动时间：自2020年7月31日至2020年12月23日，以达人荟会员系统时间作为计时准据。
                    </li>
                    <li>
                        三、活动内容：
                        <ul>
                            <li>
                                (一)活动期间，达人荟会员在达美乐线上订餐渠道完整地填写和提交如下全部信息之后，可获得20奖励积分。未完全填写、填写部分信息的，会员将无法获得本活动奖励积分。<br/>
                                - 账户昵称<br/>
                                - 性别<br/>
                                - 生日<br/>
                                - 家庭成员人数(含本人)<br/>
                                - 子女人数<br/>
                                - 子女出生年月<br/>
                            </li>
                            <li>
                                (二)为向各位会员提供更丰富的、更贴切的个性化会员服务，达美乐申请收集各位会员的以上信息。会员可以查阅达美乐官网公示的《个人信息保护政策》了解更详细的关于以上个人信息收集目的、使用、存储等方面的信息。
                            </li>
                            <li>
                                (三)本活动的奖励积分由会员系统按接收信息的时间顺序和处理数据的功能能力、尽快发送至符合条件的会员账户。
                            </li>
                        </ul>
                    </li>
                    <li>
                        四、每一名达人荟会员仅可参加一次本活动，且一次性领取本活动的奖励积分。
                    </li>
                    <li>
                        五、会员可以查阅达人荟《会员章程》了解奖励积分的使用规则、有效期。
                    </li>
                    <li>
                        六、如您需要更多信息或帮助，请在服务时间段内联系达美乐客服中心电话4001-597-597。
                    </li>
                </ul>
                <h2 style="text-align: right;padding-right: 10px;">
                    达美乐中国
                </h2>
            </div>

        </template>
    </base-layout>
</template>
<script>
	import Vue from 'vue'

	// 隐私协议更新版本日期
	const versionTime = '2019年9月9日';
	const PrivacyProtocolName = '__cache__key__PrivacyProtocol__'

	import baseLayout from "@comm/view/layout/baseLayout";

	export default {
		name: 'systemProtocolDarenExplain',
		props: {
			isShowHeader: {
				type: Boolean,
				default: true
			},
			showTitle: {
				type: Boolean,
				default: true
			},
		},
		data() {
			return {
				versionTime,
				isShowDocs: true
			};
		},
		components: {
			baseLayout
		},
		methods: {
			onShowInfo() {
				this.isShowDocs = !this.isShowDocs;
				this.$nextTick(() => {
					let dialogBox = document.querySelector('.dialog-body');
					let viewBox = document.querySelector('.child-view');
					dialogBox ? dialogBox.scrollTop = '0px' : viewBox.scrollTop = '0px'
				})

			}
		}
	};

	// 版本检查
	function checkVersion() {
		let oldVersionTime = Vue.$localStore.get(PrivacyProtocolName);
		// 对比版本是否一致
		if (oldVersionTime == versionTime) {
			// 表示无更新
			return false;
		}
		// 表示更新
		return true;
	}

	// 更新版本
	function updateVersion() {
		Vue.$localStore.set(PrivacyProtocolName, versionTime);
	}

	export {
		versionTime,
		checkVersion,
		updateVersion,
	}
</script>

<style lang="scss" scoped>

    * {
        font-size: 12px;
    }

    .docs {
        border: none;
        outline: none;
        &.padding {
            padding: 15px;
        }
    }

    h2 {
        color: #333;
        font-size: 18px;
        font-weight: 700;
        padding: 10px 0;
    }

    h3 {
        color: #af1515;
        font-size: 14px;
        font-weight: 700;
        padding: 10px 0;
    }

    .info-text {
        font-size: 14px;
        padding: 5px 0;
    }

    .info-title {
        font-size: 14px;
        font-weight: 700;
    }

    .btn-box {
        text-align: center;
    }

    .btn-back {
        background-color: #dd0404;
        border: none;
        padding: 10px 40px;
        color: #fff;
        border-radius: 5px;

    }

    .btn-container {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 15px;
        padding-bottom: 15px;
    }

    button.back {
        color: white;
        border: none;
        outline: none;
        width: 100px;
        padding: 5px 10px;
        background-color: red;
    }

    .underline {
        text-decoration: underline;
    }

    .normal {
        font-size: 14px;
    }

    .red {
        /*color: red;*/
    }

    .bold {
        font-weight: bold;
    }

    .padding-top {
        padding-top: 10px;
    }

    p, h3, h2 {
        &.warin {
            color: red;
        }
    }

    .doc-title {
        text-align: center;
    }

    .sub-title {
        font-size: 13px;
    }

    .info-text {
        font-size: 14px;
        padding: 5px 0;
    }

    .info-title {
        font-size: 14px;
        font-weight: 700;
        padding-top: 5px;
    }

    .btn-box {
        text-align: center;

    }

    .btn-back {
        background-color: #dd0404;
        border: none;
        padding: 10px 40px;
        color: #fff;
        border-radius: 5px;

    }

    .btn-container {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 15px;
        padding-bottom: 15px;
    }

    button.back {
        color: white;
        border: none;
        outline: none;
        width: 100px;
        padding: 5px 10px;
        background-color: red;
    }

    p, h3, h2 {
        &.warin {
            color: red;
        }
    }

    img {
        width: 100%;
    }

    .link {
        font-style: italic;
        text-decoration: underline;
    }

    .bold {
        font-weight: bold;
    }
</style>